export enum MeasureSystem {
  SI = 1,
  IP = 2
}
